import { useUserStore } from '@/stores/user.store';
import LoadingLayout from '@/components/layouts/loading-layout.vue';

export default {
  name: 'login',
  path: '/login',
  component: LoadingLayout,
  meta: {
    title: 'Login',
    authenticated: false,
    activeUser: false,
    enabled: true,
  },
  async beforeEnter(to) {
    // logout of everything
    useUserStore().logout();

    // get the token, config, jwt, and adminId parameters off the query string
    const { token, config, jwt } = to.query;

    // if jwt is present, login with JWT
    if (jwt) useUserStore().loginFromJwt(jwt);

    // if token is present, login with token
    if (token) {
      await useUserStore().loginFromToken(token, config || 'production');
    }

    // Redirect to the root route after login
    return { name: 'root' };
  },
};
